import axios from 'axios';
import qs from 'qs';
import { starter2Api, crmApi } from '../constants/Endpoint';
import { adios } from '@adserve/adserve-react-components';
import {
    campaignStationsArrayToDictionary,
    campaignStationsDictionaryToArray,
    getCampaignGoalDefaults,
    formatGoal,
    generateMonthlyPoNumbers,
    sanitiseGoal
    // dateAppliedTimezone
} from './UtilsService';
import { createNote } from './NoteService';
import moment from 'moment';
import { performance_dummy_data, campaignData } from './dummy_performance_data';
import { CampaignGoalEnum } from '../constants/Enums';

export const GetAll = async (ep) => {
    const result = await adios(() => axios.get(`${starter2Api}/${ep}`));
    return result?.data.data;
};
export const Get = async (ep, id) => {
    const result = await adios(() => axios.get(`${starter2Api}/${ep}/${id}`));
    return result?.data;
};
export const GetPropertiesStats = async (properties) => {
    return [];
};
export const GetPropertyTotals = async (properties, campaignSurveyId, campaignDemoId) => {
    const requestProperties = [];
    properties?.forEach((p) => {
        const newp = {
            id: p.id === window.emptyGuid ? p.sandPPropertyId : p.id,
            weeks: p.weeks,
            startDate: moment(p.startDate).utc(true).startOf('day').toISOString(),
            endDate: moment(p.endDate).utc(true).startOf('day').toISOString(),
            propertyDurationType: p.propertyDurationType,
            demographicId: campaignDemoId
        };
        //  if (p?.id && p?.id !== window.emptyGuid) {
        requestProperties.push({ ...newp, linkedStationNames: JSON.stringify(p?.linkedStationNames) });
        // }
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/propertySelections/Totals`, {
            properties: requestProperties,
            surveyId: campaignSurveyId
        })
    );
    return result?.data;
};
export const LoadPropertyDealPrice = async (propertyIds, campaign) => {
    return 0;
};
export const GetCampaignSettings = async () => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignsettings`));
    return result?.data;
};
export const GetCampaignPerformancePdfNew = async (html) => {
    const result = await adios(() =>
        axios({
            url: `${starter2Api}/pdf/HTMLtoPDF/something.pdf`,
            method: 'post',
            headers: { 'Content-Type': 'text/plain' },
            data: html
        })
    );
    return result?.data;
};

export const GetAccountSettings = async () => {
    const result = await adios(() => axios.get(`${starter2Api}/accountsettings`));
    return result?.data;
};

export const GetActiveDiscountWorkflowRequest = async (workflowId, campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflowRequest/${workflowId}/${campaignId}`));
    return result?.data;
};

export const GetActiveValuePotWorkflowRequest = async (workflowId, campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflowRequest/${workflowId}/${campaignId}`));
    return result?.data;
};

export const GetActiveSpotTypeDistributionWorkflowRequest = async (workflowId, campaignId) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/workflowRequest/${workflowId}/${campaignId}`, {
            params: {
                includeDenied: true
            }
        })
    );
    return result?.data;
};

export const GetActiveCancellationWorkflowRequest = async (workflowId, campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflowRequest/${workflowId}/${campaignId}`));
    return result?.data;
};

export const GetOpportunity = async (id) => {
    const result = await adios(() => axios.get(`${crmApi}/opportunity/${id}/dto`));
    return result?.data;
};

export const GetQuote = async (id, params) => {
    const result = await adios(() => axios.get(`${starter2Api}/quote/${id}`, params));
    return result?.data;
};

export const GetQuotePdf = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/quote/${id}/pdf`));
    return result?.data;
};

export const GetQuotableObjects = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/campaign/${id}/QuotableObjects`, {
            params
        })
    );
    return results?.data;
};

export const GetSandPProperties = async (params) => {
    return [];
};
export const GetQuotes = async (id, campaignBurstId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/campaign/${id}/Quotes/Search`, {
            params: {
                ...params,
                campaignBurstId
            }
        })
    );
    return results?.data;
};

export const GetActiveQuotes = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/campaign/${id}/Quotes/Search`, {
            params: {
                ...params,
                activeQuotesOnly: true
            }
        })
    );
    return results?.data;
};

export const CreateQuote = async (quote) => {
    const result = await adios(() => axios.post(`${starter2Api}/quote`, quote));
    return result.data;
};

export const UpdateQuote = async (quote) => {
    const result = await adios(() => axios.patch(`${starter2Api}/quote`, quote));
    return result.data;
};

export const ExpireQuote = async (quoteId) => {
    const result = await adios(() =>
        axios.patch(`${starter2Api}/quote/expireQuote`, {
            id: quoteId
        })
    );
    return result.data;
};

export const CheckingQuotePriceAgainstBalances = async (
    campaignId,
    campaignBusinessType,
    campaignBurstId,
    isBurst,
    planId
) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/quote/checkbalance`, {
            params: {
                CampaignId: campaignId,
                BusinessType: campaignBusinessType,
                CampaignBurstId: campaignBurstId,
                IsBurst: isBurst,
                PlanId: planId
            }
        })
    );
    return result.data;
};

export const CreateCampaign = async (campaign, selectedProperties = []) => {
    campaign.advancedOptions.applicableDayParts = JSON.stringify(campaign.applicableDayParts);
    campaign.advancedOptions.dayWeights = JSON.stringify(campaign.dayWeights);

    for (const row of selectedProperties) {
        if (row.sandPPropertyTypeName === 'Finite') {
            if (typeof row?.weeks === 'undefined' && row?.weekNumber) {
                row.weeks = row?.weekNumber;
            }
        }
    }

    campaign.campaignGoal.forEach((goal) => {
        if (goal.values) {
            goal.values = JSON.stringify(goal.values);
        }
    });
    campaign.campaignAttachments = null; // Attachments are handled separately see CreateCampaign on CampaignPage
    const campaignNotes = campaign.campaignNotes || [];
    campaign.campaignNotes = null;
    campaign.budget = campaign.budget ?? 0;
    const validSelectedProperties = [...selectedProperties];
    validSelectedProperties?.forEach((vsp) => {
        vsp.linkedStationNames = JSON.stringify(vsp?.linkedStationNames);
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/campaign`, {
            ...campaign,
            propertySelections: validSelectedProperties,
            campaignStations: JSON.stringify(campaignStationsArrayToDictionary(campaign.campaignStations))
        })
    );

    try {
        campaignNotes?.forEach((note) => {
            note.entityId = result.data.id;
            createNote(note, 'campaign');
        });
    } catch (err) {
        console.error(err);
    }

    return result.data;
};

export const GetCampaignStaticData = async () => {
    const results = await adios(() => axios.get(`${starter2Api}/CampaignStaticData`));
    console.log(results);
    results.data.scriptFactors = results.data.scriptFactors.filter((f) => f.availableForPlanning);
    return { ...results?.data, algorithms: [{ id: 1, name: 'Heuristic' }] };
};
export const GetPackages = async (stationId) => {
    const data = {};
    if (stationId) {
        data.stationId = stationId;
    }
    const results = await adios(() => axios.get(`${starter2Api}/SandPProperties/forStation`, { params: data }));
    return results?.data;
};
export const GetDealsForCampaign = async (filter) => {
    const sDate = moment(filter?.startDate ?? undefined)
        .utc(true)
        .startOf('day')
        .toISOString();
    const eDate = moment(filter?.endDate ?? undefined)
        .utc(true)
        .startOf('day')
        .toISOString();
    const results = await adios(() =>
        axios.get(`${starter2Api}/Deals/Lookup`, {
            params: {
                pageNumber: 1,
                pageSize: -1,
                advertiserId: filter.advertiserId,
                agencyId: filter.agencyId,
                revenueTypeId: filter.revenueTypeId,
                campaignId: filter.campaignId,
                startDate: sDate,
                endDate: eDate,
                dealVersionId: filter.dealVersionId
            },
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );
    return results.data.data;
};

export const GetCampaignInListingFormat = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaigns/${id}/dto`));
    return result?.data;
};

export const GetCurrentTime = () => {
    const dt = new Date();
    const s =
        dt.getFullYear() +
        '-' +
        (dt.getMonth() < 9 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1) +
        '-' +
        (dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()) +
        'T' +
        (dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()) +
        ':' +
        (dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()) +
        ':' +
        (dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds());

    return s;
};
export const GetBillingPlanTarget = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaign/${id}/BillingPlanTarget`));
    return result.data;
};
export const DeleteCampaignBurst = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/campaignburst/${id}`));
    return result.data;
};

export const GetCampaignBursts = async (id) => {
    if (id === undefined) {
        return [];
    }
    const result = await adios(() => axios.get(`${starter2Api}/campaignbursts/${id}`));
    return result.data;
};

export const GetCampaignBurst = async (id, campaignId) => {
    const url = campaignId ? `${starter2Api}/campaignburst/${id}/${campaignId}` : `${starter2Api}/campaignburst/${id}`;
    const result = await adios(() => axios.get(url));

    const burst = result?.data;

    burst.burstStations = campaignStationsDictionaryToArray(JSON.parse(burst.burstStations));

    if (burst.advancedOptions.applicableDayParts) {
        burst.applicableDayParts = JSON.parse(burst.advancedOptions.applicableDayParts);
        burst.dayWeights = JSON.parse(burst.advancedOptions.dayWeights);
        burst.distributionStationsChanged = false;
    }

    if (burst.advancedOptions.budgetAllocations) {
        burst.budgetAllocations = JSON.parse(burst.advancedOptions.budgetAllocations);
    }

    const goalBurstToUpdate = burst.campaignGoal.find((g) => g.goal === CampaignGoalEnum.BUDGET);
    if (goalBurstToUpdate.value === 0 || goalBurstToUpdate.value === null) {
        goalBurstToUpdate.value = burst.budget;
    }

    // This record could be older (or corrupt) so reset to defaults
    if (!Array.isArray(burst.campaignGoal)) {
        burst.campaignGoal = getCampaignGoalDefaults();
    }
    burst.campaignGoal = sanitiseGoal(burst.campaignGoal);
    burst.campaignGoal = formatGoal(burst.campaignGoal);

    return burst;
};

export const CreateCampaignBurst = async (campaignBurst) => {
    const payload = { ...campaignBurst };
    // Deep copy
    payload.campaignGoal = JSON.parse(JSON.stringify(payload.campaignGoal));
    payload.campaignGoal.forEach((goal) => {
        if (goal.values) {
            goal.values = JSON.stringify(goal.values);
        }
    });

    const result = await adios(() =>
        axios.post(`${starter2Api}/campaignBurst`, {
            ...payload,
            burstStations: JSON.stringify(campaignStationsArrayToDictionary(campaignBurst.burstStations))
        })
    );
    return result.data;
};

export const UpdateCampaignBurst = async (campaignBurst) => {
    try {
        const payload = { ...campaignBurst };

        // Deep copy
        payload.campaignGoal = JSON.parse(JSON.stringify(payload.campaignGoal));
        payload.campaignGoal.forEach((goal) => {
            if (goal.values) {
                goal.values = JSON.stringify(goal.values);
            }
        });

        const advancedOptions = campaignBurst.advancedOptions;
        advancedOptions.applicableDayParts = JSON.stringify(campaignBurst.applicableDayParts);
        advancedOptions.dayWeights = JSON.stringify(campaignBurst.dayWeights);
        advancedOptions.budgetAllocations = JSON.stringify(campaignBurst.budgetAllocations);

        const result = await adios(() =>
            axios.patch(`${starter2Api}/campaignBurst`, {
                ...payload,
                burstStations: JSON.stringify(campaignStationsArrayToDictionary(campaignBurst.burstStations)),
                advancedOptions: advancedOptions
            })
        );
        return result.data;
    } catch (err) {
        console.log(err);
    }
};

export const GetCampaignPackages = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignpackages/${id}`));
    return result.data;
};
export const GetCampaignProperties = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignproperties/${id}`));
    return result.data;
};
// ToDo: There is some duplicate code in GetCampaign() and GetCampaignFromOpportunity() - To be tidied up
export const GetCampaign = async (id, businessType) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/campaign/${id}`, {
            params: {
                currentTime: GetCurrentTime(),
                businessTypeName: businessType
            }
        })
    );
    const camp = result?.data;
    // camp.startDate = new Date(Date.parse(camp.startDate));
    // camp.endDate = new Date(Date.parse(camp.endDate));

    if (camp.currentPlan?.reservedUntil) {
        camp.currentPlan.reservedUntil = new Date(Date.parse(camp.currentPlan.reservedUntil));
    }

    // This record could be older (or corrupt) so reset to defaults
    if (!Array.isArray(camp.campaignGoal)) {
        camp.campaignGoal = getCampaignGoalDefaults();
    }
    camp.campaignGoal = sanitiseGoal(camp.campaignGoal);
    camp.campaignGoal = formatGoal(camp.campaignGoal);

    if (!camp.poNumbersJson) {
        camp.poNumbersJson = {
            single: '',
            multiple: generateMonthlyPoNumbers(camp.startDate, camp.endDate),
            usingSingle: false
        };
    }

    camp.campaignStations = campaignStationsDictionaryToArray(JSON.parse(camp.campaignStations));
    if (camp.advancedOptions.applicableDayParts) {
        camp.applicableDayParts = JSON.parse(camp.advancedOptions.applicableDayParts);
        camp.dayWeights = JSON.parse(camp.advancedOptions.dayWeights);

        // const currentStations = JSON.stringify(
        //     camp.campaignStations.map((a, b) => a.id)
        // );
        // camp.lastStations = currentStations; Commented so that RajarCaches can be retreived correctly.
    }

    if (camp.advancedOptions.budgetAllocations) {
        camp.budgetAllocations = JSON.parse(camp.advancedOptions.budgetAllocations);
    }

    return result?.data;
};

export const GetCampaignVersion = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignVersion/${id}`));
    const camp = result?.data;
    // camp.startDate = new Date(Date.parse(camp.startDate));
    // camp.endDate = new Date(Date.parse(camp.endDate));

    // if (camp.currentPlan?.reservedUntil) {
    //     camp.currentPlan.reservedUntil = new Date(Date.parse(camp.currentPlan.reservedUntil));
    // }

    // This record could be older (or corrupt) so reset to defaults
    if (!Array.isArray(camp.campaignGoal)) {
        camp.campaignGoal = getCampaignGoalDefaults();
    }
    camp.campaignGoal = sanitiseGoal(camp.campaignGoal);
    camp.campaignGoal = formatGoal(camp.campaignGoal);

    if (!camp.poNumbersJson) {
        camp.poNumbersJson = {
            single: '',
            multiple: generateMonthlyPoNumbers(camp.startDate, camp.endDate),
            usingSingle: false
        };
    }

    camp.campaignStations = campaignStationsDictionaryToArray(JSON.parse(camp.campaignStations));
    if (camp.advancedOptions.applicableDayParts) {
        camp.applicableDayParts = JSON.parse(camp.advancedOptions.applicableDayParts);
        camp.dayWeights = JSON.parse(camp.advancedOptions.dayWeights);

        // const currentStations = JSON.stringify(
        //     camp.campaignStations.map((a, b) => a.id)
        // );
        // camp.lastStations = currentStations; Commented so that RajarCaches can be retreived correctly.
    }

    if (camp.advancedOptions.budgetAllocations) {
        camp.budgetAllocations = JSON.parse(camp.advancedOptions.budgetAllocations);
    }

    return result?.data;
};

export const GetCampaignBurstVersion = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignBurstVersion/${id}`));

    result.data.committedSpend = result.data.budget;
    result.data.modified = false;

    result.data.burstStations = campaignStationsDictionaryToArray(JSON.parse(result.data.burstStations));

    if (result.data.dayWeights && result.data.applicableDayParts) {
        result.data.distributionStationsChanged = false;
    }

    if (result.data.advancedOptions.applicableDayParts) {
        result.data.applicableDayParts = JSON.parse(result.data.advancedOptions.applicableDayParts);
        result.data.dayWeights = JSON.parse(result.data.advancedOptions.dayWeights);
        result.data.distributionStationsChanged = false;
    }

    if (result.data.advancedOptions.budgetAllocations) {
        result.data.budgetAllocations = JSON.parse(result.data.advancedOptions.budgetAllocations);
    }

    return result.data;
};

// ToDo: There is some duplicate code in GetCampaign() and GetCampaignFromOpportunity() - To be tidied up
export const GetCampaignFromOpportunity = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaign/NewFromOpportunityId/${id}`));
    const camp = result?.data;
    // camp.startDate = new Date(Date.parse(camp.startDate));
    // camp.endDate = new Date(Date.parse(camp.endDate));

    // This record could be older (or corrupt) so reset to defaults
    if (!Array.isArray(camp.campaignGoal)) {
        camp.campaignGoal = getCampaignGoalDefaults();
    }
    camp.campaignGoal = sanitiseGoal(camp.campaignGoal);
    camp.campaignGoal = formatGoal(camp.campaignGoal);

    if (!camp.poNumbersJson) {
        camp.poNumbersJson = {
            single: '',
            multiple: [],
            usingSingle: false
        };
    }

    camp.campaignStations = campaignStationsDictionaryToArray(JSON.parse(camp.campaignStations));
    if (camp.advancedOptions.applicableDayParts) {
        camp.applicableDayParts = JSON.parse(camp.advancedOptions.applicableDayParts);
        camp.dayWeights = JSON.parse(camp.advancedOptions.dayWeights);
        const currentStations = JSON.stringify(camp.campaignStations.map((a) => a.id));
        camp.lastStations = currentStations;
    }

    return result?.data;
};

export const GetCampaigns = async (params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/campaigns/search?campaignTypes=${JSON.stringify(params.campaignTypes)} `, {
            params: {
                ...params,
                jcn: params.jcn
            }
        })
    );
    /* const today = new Date().toISOString().substr(0,10);

        results?.data.data.map((a,b)=> {
            console.log(a.startDate.substr(0,10),today,a.campaignStatusName)
            if ((a.startDate.substr(0,10)<=today) && (a.campaignStatusName=="Booked")) {
                a.campaignStatusName="Running"
            }
        }) */
    return results?.data;
};

export const SearchCampaignsByNameAndType = async (searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/Search`, {
            params: {
                ...params,
                name: encodeURIComponent(searchTerm)
            }
        })
    );
    /*
    const today = new Date().toISOString().substr(0,10);

        results?.data.data.map((a,b)=> {
            console.log(a.startDate.substr(0,10),today,a.campaignStatusName)
            if ((a.startDate.substr(0,10)<=today) && (a.campaignStatusName=="Booked")) {
                a.campaignStatusName="Running"
            }
        })
        */
    return results.data;
};

export const SearchCampaignsByNameStarts = async (searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/SearchByNameStarts`, {
            params: {
                ...params,
                name: encodeURIComponent(searchTerm)
            }
        })
    );

    return results.data;
};

export const SearchCampaignsByJCNStarts = async (searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/SearchByJCNStarts`, {
            params: {
                ...params,
                jcn: searchTerm
            }
        })
    );

    return results.data;
};

export const CampaignLookup = async (searchTerm, businessType = undefined) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/Lookup`, {
            params: {
                pageNumber: 1,
                pageSize: -1,
                accountId: window.emptyGuid,
                searchTerm,
                businessType
            }
        })
    );

    return results.data;
};

export const GetCampaignsByOpportunity = async (id) => {
    try {
        const results = await adios(() =>
            axios.get(`${crmApi}/Opportunity/${id}/Campaigns`, {
                params: {
                    pageSize: -1,
                    pageNumber: 1
                }
            })
        );

        return results.data?.data;
    } catch (e) {
        console.log(`An error occurred in the process. Details: ${e}`);
    }
};

export const GetContactRoles = async () => {
    const results = await adios(() => axios.get(`${crmApi}/ContactRoles`));
    return results.data.data;
};

export const UpdateCampaign = async (campaign, selectedProperties = []) => {
    const payload = { ...campaign };
    payload.externalSourceId = window.emptyGuid;
    payload.algorithmId = window.emptyGuid;
    payload.externalRef = campaign.opportunityId;
    payload.budget = campaign.budget ?? 0;

    // Deep copy
    payload.campaignGoal = JSON.parse(JSON.stringify(payload.campaignGoal));
    payload.campaignGoal.forEach((goal) => {
        if (goal.values) {
            goal.values = JSON.stringify(goal.values);
        }
    });

    payload.advancedOptions.applicableDayParts = JSON.stringify(campaign.applicableDayParts);
    payload.advancedOptions.dayWeights = JSON.stringify(campaign.dayWeights);
    payload.advancedOptions.budgetAllocations = JSON.stringify(campaign.budgetAllocations);
    for (const row of selectedProperties) {
        if (row.sandPPropertyTypeName === 'Finite') {
            if (row?.hasOwnProperty('weekNumber')) {
                if (typeof row?.weeks === 'undefined' && row?.weekNumber) {
                    row.weeks = row?.weekNumber;
                }
            }
        }
    }

    if (!campaign.reallocateUnusedBudget) {
        payload.reallocateUnusedBudget = false;
    }
    const validSelectedProperties = [...selectedProperties];
    validSelectedProperties?.forEach((vsp) => {
        vsp.linkedStationNames = JSON.stringify(vsp?.linkedStationNames);
        vsp.propertyDealPrice = vsp.dealPrice;
        vsp.startDate = moment.utc(vsp.startDate).format('YYYY-MM-DD');
        vsp.endDate = moment.utc(vsp.endDate).format('YYYY-MM-DD');
    });

    await adios(() =>
        axios.patch(`${starter2Api}/campaign`, {
            ...payload,
            propertySelections: validSelectedProperties,
            campaignStations: JSON.stringify(campaignStationsArrayToDictionary(campaign.campaignStations))
        })
    );
};

export const QualifyOutCampaign = async (campaignId, campaignBurstId = undefined) => {
    await adios(() => axios.patch(`${starter2Api}/campaign/qualifyOut`, { campaignId, campaignBurstId }));
};

export const DeleteCampaign = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/Campaign/${id}`));
    return result?.data;
};

export const CancelCampaign = async (campaignId, campaignBurstId = undefined) => {
    await adios(() => axios.post(`${starter2Api}/BookingRequest/Cancel`, { campaignId, campaignBurstId }));
};

export const AmendCampaign = async (campaignId) => {
    await adios(() => axios.post(`${starter2Api}/Campaign/Amend`, { campaignId }));
};

export const DiscardCampaign = async (campaignId) => {
    await adios(() => axios.patch(`${starter2Api}/Campaign/Discard`, { campaignId }));
};

export const AmendCampaignBurst = async (campaignBurstId) => {
    await adios(() => axios.post(`${starter2Api}/CampaignBurst/Amend`, { campaignBurstId }));
};

export const DiscardCampaignBurst = async (campaignBurstId) => {
    await adios(() => axios.patch(`${starter2Api}/CampaignBurst/Discard`, { campaignBurstId }));
};

export const CopyQuote = async (quote) => {
    const result = await adios(() => axios.post(`${starter2Api}/Quote/Copy`, { id: quote.id }));
    return result.data;
};

export const DeleteQuote = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/Quote/${id}`));
    return result?.data;
};

export const ToggleCampaignFavourite = async (id) => {
    await adios(() => axios.post(`${starter2Api}/favourite/campaign`, { id }));
};

export const GetPlan = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/plan/${id}`));
    return result?.data;
};

export const GetPlanSummary = async (planId, stationId, campaignVersionId, isBurst) => {
    let sendStationId;
    if (stationId !== 0 && stationId !== '-1') {
        sendStationId = stationId;
    }
    const result = await adios(() =>
        axios.get(`${starter2Api}/Plan/SummaryByDayparts`, {
            params: {
                id: planId,
                campaignVersionId: campaignVersionId,
                stationId: sendStationId,
                isBurst: isBurst
            }
        })
    );
    return result?.data;
};

export const GetPlanCpts = async (planId, stationId) => {
    planId = planId ?? window.emptyGuid;
    stationId = !stationId ? window.emptyGuid : stationId;

    if (stationId === window.emptyGuid) {
        const result = await adios(() => axios.get(`${starter2Api}/plan/${planId}/cpt`));
        return result.data;
    } else {
        const result = await adios(() => axios.get(`${starter2Api}/plan/${planId}/cpt/?stationId=${stationId}`));
        return result.data;
    }
};

export const GetPlanSummaryBooked = async (campaignId, stationId) => {
    let sendStationId;
    if (stationId !== 0 && stationId !== '-1') {
        sendStationId = stationId;
    }
    const result = await adios(() =>
        axios.get(`${starter2Api}/Plan/SummaryByDaypartsBooked`, {
            params: {
                id: campaignId,
                stationId: sendStationId
            }
        })
    );
    return result?.data;
};

export const GetSandPPlanSummary = async (campaignId, startDate, endDate) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Plan/SummaryByDayPartsForSandPPerformance`, {
            params: {
                id: campaignId,
                startDate: moment(startDate).utc(true).startOf('day').toISOString(),
                endDate: moment(endDate).utc(true).startOf('day').toISOString()
            }
        })
    );
    return result?.data;
};

export const GetOtherPlanSummary = async (campaignId, stationId) => {
    let sendStationId;
    if (stationId !== 0 && stationId !== '-1') {
        sendStationId = stationId;
    }

    const result = await adios(() =>
        axios.get(`${starter2Api}/Plan/SummaryByDaypartsPerformanceTab`, {
            params: {
                id: campaignId,
                stationId: sendStationId
            }
        })
    );
    return result?.data;
};

export const GetAllStationSummary = async (planId, impactOption, campaignVersionId) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Plan/AllStationSummary`, {
            params: {
                id: planId,
                showBaseImpacts: impactOption,
                campaignVersionId: campaignVersionId
            }
        })
    );
    return result?.data;
};

export const GetPlanAudienceTotals = async (planId) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/PlanOptimisationRequest/byPlanId`, {
            params: {
                id: planId
            }
        })
    );
    return result?.data;
};

export const GetCampaignBurstsSummary = async (campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/CampaignBursts/summary/${campaignId}`));
    return result?.data;
};

export const GetPlanPdf = async (id) => {
    const response = await fetch(`${starter2Api}plan/${id}/pdf`);
    const blob = await response.blob();
    return window.URL.createObjectURL(blob);
};

export const GetCampaignPerformancePdf = async (campaignId, stationId, showMonthly) => {
    const response = await adios(() =>
        axios.get(`${starter2Api}/campaign/${campaignId}/performancepdf`, {
            params: {
                stationId: stationId,
                showMonthly: showMonthly
            }
        })
    );

    return response.data;
};

// need to implement live API end points
export const GetOrderPerformance = async () => {
    return performance_dummy_data;
};

// real API for performance
export const getCampaignPerformance = async (campaignId, filters) => {
    const params = { id: campaignId };
    if (filters.stationId && filters.stationId !== '0') {
        params.stationId = filters.stationId;
    }
    if (filters.scriptFactorId && filters.scriptFactorId !== '0') {
        params.scriptFactorId = filters.scriptFactorId;
    }
    if (filters.demographicId && filters.demographicId !== '0') {
        params.demographicId = filters.demographicId;
    }
    if (filters.surveyId) {
        params.surveyId = filters.surveyId;
    }
    if (filters.dayPartId && filters.dayPartId != -1) {
        params.dayPartId = filters.dayPartId;
    }
    if (filters.scriptFactorId && filters.scriptFactorId !== '0') {
        params.scriptFactorId = filters.scriptFactorId;
    }
    /* ==========================Multi select options =========================*/
    if (filters.spotTypeIds && filters.spotTypeIds.length) {
        params.spotTypeIds = filters.spotTypeIds;
    }
    if (filters.scriptFactorIds && filters.scriptFactorIds.length) {
        params.scriptFactorIds = filters.scriptFactorIds;
    }
    if (filters.stationIds && filters.stationIds.length) {
        params.stationIds = filters.stationIds;
    }
    if (filters.dayPartIds && filters.dayPartIds.length) {
        params.dayPartIds = filters.dayPartIds;
    }
    if (filters.propertySelectionIds && filters.propertySelectionIds.length) {
        params.propertySelectionIds = filters.propertySelectionIds;
    }
    if (filters.campaignBurstIds && filters.campaignBurstIds.length) {
        params.campaignBurstIds = filters.campaignBurstIds;
    }
    /* ==========================End Multi select options =========================*/

    if (filters.versionId && filters.versionId !== '0') {
        params.versionId = filters.versionId;
    }
    if (filters.propertySelectionId && filters.propertySelectionId !== '0') {
        params.propertySelectionId = filters.propertySelectionId;
    }
    if (filters.campaignBurstId && filters.campaignBurstId !== '0') {
        params.campaignBurstId = filters.campaignBurstId;
    }
    if (filters.dateRange) {
        params.startDate = moment(filters.dateRange[0]).format('YYYY-MM-DD');
        params.endDate = moment(filters.dateRange[1]).format('YYYY-MM-DD');
    }
    const response = await adios(() => axios.post(`${starter2Api}/campaign/campaignAnalysisPca`, params));

    return response.data;
};

export const FilterCustomReport = async () => {
    return [];
};

export const GetSpotTypes = async () => {
    const results = await adios(() => axios.get(starter2Api + '/spottypes/?pageSize=1000'));
    return results?.data?.data;
};

export const GetScriptLengths = async () => {
    const results = await adios(() => axios.get(starter2Api + '/scriptfactors/?pageSize=1000'));

    return results?.data?.data.filter((f) => f.availableForPlanning);
};

export const GetAlgorithms = async () => {
    const results = [{ id: 1, name: 'Heuristic' }];
    return results;
};

export const GetCampaignStatuses = async () => {
    const result = await adios(() => axios.get(`${starter2Api}/CampaignStatuses`));

    return result?.data?.data;
};

export const GetOffairActivitiesByQuoteId = async (quoteId, params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Quote/${quoteId}/OffairActivities`, {
            params: params
        })
    );
    return result?.data.data;
};

export const GetOffairActivities = async (campaignId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/OffairActivities`, {
            params: {
                ...params,
                campaignId: campaignId
            }
        })
    );
    return results?.data?.data;
};

export const GetOffairActivityHistories = async (campaignId, campaignVersionId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/OffairActivities/History`, {
            params: {
                ...params,
                campaignId: campaignId,
                campaignVersionId: campaignVersionId
            }
        })
    );
    return results?.data?.data;
};

export const GetOffairActivityHistoriesForBilling = async (campaignId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/OffairActivities/BespokeBilling`, {
            params: {
                ...params,
                campaignId: campaignId
            }
        })
    );
    return results;
};

export const GetOffairTypes = async () => {
    const results = await adios(() => axios.get(starter2Api + '/offairTypes/?pageSize=1000'));

    return results?.data?.data;
};

export const CreateOffair = async (offair) => {
    const result = await adios(() => axios.post(`${starter2Api}/offairActivity`, offair));
    return result.data;
};

export const UpdateOffair = async (offair) => {
    try {
        await adios(() => axios.patch(`${starter2Api}/offairActivity`, offair));
    } catch (e) {
        console.log(e, 'ERROR');
    }
};

export const GetOffairType = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/OffairType/${id}`));
    return result?.data;
};

export const GetAccountById = async (id) => {
    const result = await adios(() => axios.get(`${crmApi}/Account/${id}`));
    return result?.data;
};

export const DeleteOffair = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/offairActivity/${id}`));
    return result?.data;
};

export const GetCampaignSpots = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaign/${id}/Spots/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetCampaignVersionSpots = async (campaignVersionId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignVersion/${campaignVersionId}/Spots/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetCampaignBurstSpots = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignBurst/${id}/Spots/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetCampaignBurstVersionSpots = async (campaignVersionId, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignBurstVersion/${campaignVersionId}/Spots/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetCampaignTransmitters = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaign/${id}/Transmitters/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetCampaignBurstTransmitters = async (id, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignBurst/${id}/Transmitters/Search`, {
            params
        })
    );
    return results?.data;
};

export const GetTargetDeliverByCampaignId = async (id) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaign/${id}/TargetDelivery`, {
            id: id
        })
    );
    return results?.data;
};

export const CreateEntity = async (entityName, entity) => {
    const url = `${starter2Api}/${entityName}`;
    let data = {};

    await axios.post(url, entity).then((result) => {
        data = result;
    });
    return data;
};

export const GetValue = async (entity, id) => {
    const url = `${starter2Api}/${entity}/${id}`;
    let data = [];

    await adios(() =>
        axios
            .get(url, {
                headers: {
                    Accept: 'application/json'
                }
            })
            .then((result) => {
                data = result.data;
            })
    );

    return data;
};

export const GetHeatMapData = async (postObj) => {
    const result = await adios(() => axios.post(`${starter2Api}/HeatMapData/WeeklyForStations/`, postObj));

    return result;
};

export const GetReservations = async (params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/quotes/search?activeOnly=true`, {
            params
        })
    );
    return results?.data;
};

export const CreateOffAirQuote = async (offAirQuote) => {
    const result = await adios(() => axios.post(`${starter2Api}/quote`, offAirQuote));
    return result.data;
};

export const GetCampaignSplitStatistics = async (postObj) => {
    const result = await adios(() => axios.post(`${starter2Api}/CampaignSplitStatistics/GetStatistics/`, postObj));
    return result;
};

export const GetCampaignJourneyBarSteps = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/JourneyBarSteps/ForBar?Module=CampaignManager`));
        return result?.data;
    } catch (e) {
        return [];
    }
};

export const GetReservationTimes = async () => {
    try {
        const result = await GetAll('reservationTimes');

        const times = [];
        let id = 0;

        result?.forEach((time) => {
            times.push({
                id: id++,
                name: time.name,
                hours: time.minutes / 60,
                default: time.isDefault
            });
        });

        const values = [
            { name: 'Extend Reservation', style: { textAlign: 'left' } },
            ...times,
            { name: 'Release Reservation', style: { textAlign: 'left' } },
            { id: 255, name: 'Release' }
        ];

        return values;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const GetVatRates = async () => {
    try {
        const result = await GetAll('vats');

        return result;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const GetVatDates = async () => {
    try {
        const result = await GetAll('vatDates');

        return result;
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const CreateInvoice = async (invoice) => {
    const result = await adios(() => axios.post(`${starter2Api}/invoice`, invoice));

    return result.data;
};

export const GetCampaignForwardSchedule = async (params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/campaign/forwardschedule/`, {
            params
        })
    );
    return results?.data;
};

export const UpdateBillingPlanByCampaignId = async (campaignId) => {
    await adios(() =>
        axios.patch(`${starter2Api}/Campaign/billingPlan`, {
            id: campaignId
        })
    );
    return true;
};

export const GetCampaignInvoiceHeaders = async (
    params,
    showInvoiceRuns = true,
    showIndividualInvoices = true,
    showCreditNotes = true
) => {
    // TODO: find a neater way to get flagged enums to play with
    let show = '';
    if (showInvoiceRuns) {
        show += 'InvoiceRuns,';
    }
    if (showIndividualInvoices) {
        show += 'IndividualInvoices,';
    }
    if (showCreditNotes) {
        show += 'CreditNotes,';
    }

    params = {
        ...params,
        show: show.substring(0, show.length - 1)
    };

    const results = await adios(() =>
        axios.get(`${starter2Api}/invoiceHeaders/search`, {
            params
        })
    );

    return results?.data;
};

export const GetInvoice = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/invoice/${id}`));

    return result?.data;
};

export const UpdateBillingPlanInvoice = async (invoice) => {
    const result = await adios(() => axios.patch(`${starter2Api}/billingPlanInvoice`, invoice));

    return result?.data;
};

export const GetBillingPlanInvoicesByCampaign = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/billingPlanInvoices/ByCampaign/${id}`));

    return result?.data;
};

export const DeleteBillingPlanInvoicesByCampaign = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/billingPlanInvoices/ByCampaign/${id}`));
    return result?.data;
};

export const GetCreditDetailsByCampaign = async (campaignId, billingAccountId) => {
    const result = await adios(() =>
        axios.get(
            `${starter2Api}/billingPlanInvoices/CreditDetails/?campaignId=${campaignId}&billingAccountId=${billingAccountId}`
        )
    );

    return result?.data;
};

export const GetBillingPlanInvoicesById = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/billingPlanInvoice/${id}`));

    return result?.data;
};

export const DeleteBillingPlanInvoice = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/billingPlanInvoice/${id}`));
    return result?.data;
};

export const DeleteBillingPlanInvoiceLine = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/billingPlanInvoiceLine/${id}`));
    return result?.data;
};

export const GetActivePropertiesDetails = async (
    stationId,
    name,
    sponsorships,
    partnerships,
    includeRunning,
    propertyCostingTypeId
) => {
    const result = await adios(() =>
        axios.get(
            `${starter2Api}/SandPProperties/Active/Search/?includeHistoric=${includeRunning}&stationId=${
                stationId == -1 ? '00000000-0000-0000-0000-000000000000' : stationId
            }&searchTerm=${name}&showSponsorships=${sponsorships}&showPartnerships=${partnerships}&sandPPropertyCostingTypeId=${propertyCostingTypeId}`
        )
    );
    return result?.data;
};

export const GetSandPPropertyById = async (id, parentId) => {
    const result = await adios(() =>
        axios.get(
            `${starter2Api}/SandPProperty/Campaign/?id=${id}&propertyParentId=${
                parentId ? parentId : '00000000-0000-0000-0000-000000000000'
            }`
        )
    );
    return result?.data;
};

export const GetPropertySelectionById = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/PropertySelection/${id}`));
    return result?.data;
};

export const DeletePropertySelectionById = async (id, campaignId) => {
    const result = await adios(() =>
        axios.delete(`${starter2Api}/PropertySelection/${id}?id=${id}&campaignId=${campaignId}`)
    );
    return result?.data;
};

export const GetPropertySelectionHistories = async (campaignId, campaignVersionId) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/PropertySelections/History`, {
            params: {
                campaignId,
                campaignVersionId
            }
        })
    );
    return results?.data;
};

export const GetPropertyVariances = async (requestedProperties = []) => {
    const result = await adios(() =>
        axios.post(`${starter2Api}/SandPProperty/Variances`, { requestedProperties: requestedProperties })
    );
    return result?.data;
};

export const GetStations = async () => {
    const response = await adios(() => axios.get(`${starter2Api}/Stations/SelectList`));

    return response?.data;
};

export const GetPropertyCostingTypes = async () => {
    const response = await adios(() => axios.get(`${starter2Api}/SandPPropertyCostingTypes/active/?pageSize=1000`));

    return response?.data;
};

export const GetSandPPropertyTypes = async () => {
    const response = await adios(() => axios.get(`${starter2Api}/SandPPropertyTypes/?pageSize=1000`));

    return response?.data;
};

export const GetLatestPlan = async (campaignId, campaignBurstId) => {
    const response = await adios(() =>
        axios.get(`${starter2Api}/campaign/${campaignId}/latestPlan`, {
            params: {
                campaignBurstId
            }
        })
    );

    return response?.data;
};

export const SendQuoteToJet = async (quoteId, rictType) => {
    const result = await adios(() => axios.post(`${starter2Api}/RictFile/ExportToJet`, { quoteId, rictType }));
    return result;
};

export const UpdatePropertyAvailabilities = async (bookedProperties = []) => {
    const result = await adios(() =>
        axios.post(`${starter2Api}/SandPProperties/Availabilities`, { bookedProperties: bookedProperties })
    );
    return result?.data;
};

export const ValidateJcn = async (jcn) => {
    if (jcn === '') {
        return true;
    }

    const num = Number(jcn);
    if (num === 0 || isNaN(num)) {
        return false;
    }

    const response = await adios(() =>
        axios.get(`${starter2Api}/jet/validateJcn`, {
            params: {
                jcn
            }
        })
    );

    return response?.data;
};

export const GetQuoteFormats = async () => {
    const result = await adios(() => axios.get(`${starter2Api}/quote/formats`));
    return result;
};

export const GetQuoteTotals = async (planId) => {
    const result = await adios(() => axios.get(`${starter2Api}/quote/totals`, { params: { planId } }));
    return result;
};

export const GetQuoteOffairTotals = async (campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/quote/offairtotals`, { params: { campaignId } }));
    return result;
};

export const GetQuoteType = async (campaignId, campaignBurstId) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/quote/type`, { params: { campaignId, campaignBurstId } })
    );
    return result.data;
};

export const CreateEmptyPlan = async (campaignId) => {
    const result = await adios(() => axios.post(`${starter2Api}/plans/emptyPlan`, { campaignId }));

    return result.data;
};

export const DownloadTransmissionTimesPdf = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/campaign/transmissionTimes/pdf`, {
            params
        })
    );
    return result.data;
};

export const DownloadBurstTransmissionTimesPdf = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/campaignBurst/transmissionTimes/pdf`, {
            params
        })
    );
    return result.data;
};

export const GetBillingTabSummary = async (campaignId) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/OrderSpots/BillingTabSummary/?campaignId=${campaignId}`)
    );

    return result.data;
};

export const GetAllEffectiveVats = async (date) => {
    const results = await adios(() => axios.get(starter2Api + '/Vats/AllEffectiveVats', { params: { date } }));
    const res = results?.data;
    res.forEach((v) => {
        v.id = v.vatDateId;
        v.name = `${v.name} (${v.rate}%)`;
    });
    return res;
};

export const GetCampaignLock = async (campaignId) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaignLock/${campaignId}`));

    return result?.data;
};

export const CreateCampaignLock = async (campaignId) => {
    const result = await adios(() =>
        axios.post(`${starter2Api}/campaignLock`, {
            campaignId: campaignId
        })
    );
    return result.data;
};

export const UpdateCampaignLock = async (campaignId, isReleasedLock) => {
    if (campaignId && campaignId !== window.emptyGuid) {
        const result = await adios(() =>
            axios.patch(`${starter2Api}/campaignLock`, {
                campaignId: campaignId,
                isReleasedLock: isReleasedLock
            })
        );
        return result.data;
    }
};

export const GetCampaignLockSettings = async () => {
    const results = await adios(() => axios.get(`${starter2Api}/CampaignLockSettings`));
    return results?.data;
};

export const GetOpenBillingPeriod = async () => {
    const results = await adios(() => axios.get(`${starter2Api}/BillingPeriod/open`));
    return results?.data;
};
export const GetCampaignPropertyStats = async (id) => {
    const results = await adios(() => axios.get(`${starter2Api}/campaign/${id}/propertystats`));
    return results?.data;
};

export const GetDealStationPrices = async () => {
    try {
        const result = await adios(() =>
            axios.get(`${starter2Api}/DealStationDefaultPrices/complete`, {
                params: {
                    pageNumber: 1,
                    pageSize: 5000
                }
            })
        );
        return result?.data;
    } catch (e) {
        return [];
    }
};

export const GetPropertyStats = async (data) => {
    try {
        return await adios(() => axios.post(`${starter2Api}/SandPProperty/GetStatsWithoutId`, data));
    } catch (e) {
        return { data: {} };
    }
};

export const GetSandPPropertyDefinition = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/SandPProperty/Definition/?id=${id}`));
    return result?.data;
};

export const GetCampaignStations = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaign/${id}/Stations/Search`));
    return result.data;
};

export const GetPlanStations = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/plan/${id}/Stations/Search`));
    return result.data;
};

export const GetLatestVersionCampaignDiscounts = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/campaign/${id}/GetLatestVersionCampaignDiscounts`));
    return result.data;
};
